import React from 'react';

export const LazyTeamHeader = React.lazy(() =>
  import(/* webpackChunkName: "team" */ './TeamHeader'),
);
